// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54342de2","648":"165433dd","798":"f9ca797a"}[chunkId] + ".chunk.js";
};